"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
exports.StaticImplements = function () {
    return function (constructor) { constructor; };
};
exports.assocValue = function (original, json) {
    return original !== null && typeof original === 'object'
        ? Array.isArray(original)
            ? (Array.isArray(json) && json || []).map(function (item, index) {
                return exports.assocValue(original[index], item);
            })
            : exports.factory(original !== null && original !== void 0 ? original : {}, json || {})
        : json !== null && json !== void 0 ? json : original;
};
exports.factory = function (object, json) { return (Object.assign(object, Object.keys(json || {}).reduce(function (objectFactory, key) {
    objectFactory[key] = exports.assocValue(object[key], json[key]);
    return objectFactory;
}, {}))); };
exports.formatDate = function (date) {
    var start_date = moment_1.default(date.start || new Date()).utc().format('DD/MM/YYYY HH:mm');
    var end_date = moment_1.default(date.end || new Date()).utc().format('DD/MM/YYYY HH:mm');
    return start_date + " - " + end_date;
};
//# sourceMappingURL=utils.js.map